import axios from "axios";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import VenueTile from "./VenueTile";

import { useLocalStorage } from "../../../hooks";
import * as dashboardActions from "../../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";


import noEventImage from "../../../assets/noEventImage.svg";
import { TwButton, TwContainer, TwMainLayout } from "../../../components/tailwind";
import { clearLoadingData, loadingState, setSectionLoading } from "../../../redux/reducers/loadingReducer";
import { getUrlForServices } from "../../../utils/confighelpers";

// import * as loadingActions from "../../../redux/reducers/loadingReducer";

export default function VenueList({ navigation, profileFor, title }) {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const dashboardReduxState = useSelector(dashboardState);
  const [userToken] = useLocalStorage("userToken");
  const [venueList, setVenueList] = React.useState([]);

  React.useEffect(() => {
    dispatch(clearLoadingData());
    dispatch(setSectionLoading(true));
    (async () => {
      await getListOfVenues();
      dispatch(clearLoadingData());
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleSessionClick = async (id, serviceData) => {
    // dispatch(dashboardActions.setCalendarClassData(serviceData));
    dispatch(dashboardActions.setVenueId(id));
    navigate("/myvenue/update", {
      state: {
        from: "list",
      },
    });
  };

  const getListOfVenues = async () => {
    const manageClassesConfig = {
      method: "get",
      url: `${getUrlForServices()}venue/list?getall=${true}`,
      headers: {
        "x-access-token": userToken,
      },
    };
    dispatch(setSectionLoading(true));
    const responce = await axios(manageClassesConfig);
    dispatch(setSectionLoading(false));
    if (responce.status === 200) {
      if (Array.isArray(responce.data.data)) {
        setVenueList(responce.data.data);
      }
    }
  };

  const renderVenues = (data) => {
    return (
      <ul className="divide-y divide-gray-100">
        {data.length > 0 ? (
          data.map((item, idx) => {
            const modifiedData = {
              popover: true,
              item: item,
            };
            return (
              <VenueTile
                {...modifiedData}
                key={idx}
                handleSessionClick={() => {
                  handleSessionClick(item._id, item);
                }}
                reload={() => {
                  getListOfVenues();
                }}
              />
            );
          })
        ) : (
          <li className={"text-black text-center"}>no venues are available</li>
        )}
      </ul>
    );
  };

  return (
    <TwMainLayout
      headTitle={title}
      headActions={[
        (<TwButton
          variant="orange"
          className="w-full"
          onClick={() => {
            dispatch(dashboardActions.setVenueId(-1));
            navigate("/myvenue/add", {
              state: {
                from: "list",
              },
            });
          }}
        >
          Add New Venue
        </TwButton>),
      ]}
      children={
        <TwContainer className="">
          {venueList.length ? (<div
            className={"sm:max-w-sm md:max-w-sm w-full"}
          >
            {renderVenues(venueList)}
          </div>) : (loadingReduxState.sectionLoading !== undefined && loadingReduxState.sectionLoading === false) ? (
            <div className="flex flex-col justify-center items-center gap-5 text-center h-full">
              <img
                className={"w-40 md:w-60"}
                src={noEventImage}
                alt={""}
              />
              <div className={"text-brown-coffee text-lg font-bold mt-3"}>
                No Venues Configured
              </div>
              <div className="flex justify-center items-center w-full">
                <TwButton
                  variant="orange"
                  onClick={() => {
                    dispatch(dashboardActions.setVenueId(-1));
                    navigate("/myvenue/add", {
                      state: {
                        from: "list",
                      },
                    });
                  }}
                >
                  Add a new Venue
                </TwButton>
              </div>
            </div>
          ) : ""}
        </TwContainer>} />
  );
}
